import { memberApi } from '../config/axios-config';

export const orderIdCardForUserService = (mailingAddress, tenantId, memberAccountHeader) => {
    return memberApi.post('/v3/my/orderMedicalIDCard', { mailingAddress }, {
        headers: {
            'tenant-id': tenantId,
            'member-account': memberAccountHeader
        }
    }
    );
};